import { HttpService } from 'src/api/common/HttpService';
import { CteApiUrl } from 'src/constants/BaseUrls';

export const RegionService = () => {
  const { HttpGet } = HttpService();

  const GetAll = async () => {
    const url = `${CteApiUrl}/api/v1/region`;
    const response = await HttpGet(url);
    return response;
  };

  return {
    GetAll,
  };
};
